import HeaderCarousel from './HeaderCarousel'

export default HeaderCarousel
